import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function Clock({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#clip0_839_648)">
        <path
          d="M12.4722 0.833374L14.2499 2.61115"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.6944 0.833374L0.916626 2.61115"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58327 13.0556C10.6515 13.0556 13.1388 10.5683 13.1388 7.50001C13.1388 4.43177 10.6515 1.94446 7.58327 1.94446C4.51502 1.94446 2.02771 4.43177 2.02771 7.50001C2.02771 10.5683 4.51502 13.0556 7.58327 13.0556Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.65527 11.428L2.02771 13.0555"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5112 11.428L13.1388 13.0555"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58325 4.61108V7.49997L10.0277 9.05553"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_839_648">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.083252)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
